import { Component, Input, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GenericReportViewModel, TransactionAmountModel, merchantDetails } from '../../../models/generic-report-view-model';

@Component({
  selector: 'header-report-component',
  templateUrl: './header-report.component.html',
  styleUrls: ['./header-report.component.scss']
})

export class HeaderReportComponent implements OnInit {

  @Input() startDate: string;
  @Input() endDate: string;
  @Input() grandAmount: string;
  @Input() transactionTypes: any;
  @Input() transactionAmount: any;
  @Input() merchantDetails: merchantDetails;
  header: any;

  constructor(
    private _ngxUiLoaderService: NgxUiLoaderService) {
  }

  async ngOnInit() {
    this._ngxUiLoaderService.stop();
  }

  async GetReport(_reconReport: GenericReportViewModel) {
  }

}
